import _asyncToGenerator from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import axios from '@/services/axios';
import { radar } from '@/common/log';
/**
 * 兑换功能统一接口
 */
export var applyExchange = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(params) {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            radar.event({
              eventName: '通用兑换-参数',
              extra: params
            });
            return _context.abrupt("return", axios.post('/rest/o/wallet-v2/main/exchange/apply', params, {
              silent: true
            }));
          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function applyExchange(_x) {
    return _ref.apply(this, arguments);
  };
}();